// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageArea_root__16pRU"};